import { Injectable } from '@angular/core';
import { CurrentUserDto, UserService as ApiUserService } from '@travel-planner/library-travel-planner-api';
import { Observable, of, shareReplay } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class CurrentUserService {
    private currentUserRequest: Observable<CurrentUserDto> | undefined;

    constructor(private readonly apiUserService: ApiUserService) {
    }

    getCurrentUser(): Observable<CurrentUserDto> {
        if (!this.currentUserRequest) {
            this.currentUserRequest = this.apiUserService.getCurrentUser().pipe(
                shareReplay({ bufferSize: 1, refCount: false })
            );
        }

        return this.currentUserRequest;
    }

    setCurrentUser(currentUser: CurrentUserDto): void {
        this.currentUserRequest = of(currentUser);
    }

    refreshCurrentUser(): Observable<CurrentUserDto> {
        this.currentUserRequest = undefined;
        return this.getCurrentUser();
    }
}
